import { useUser } from "$global-providers/user-provider/provider";
import { isDevEnvironment } from "$routes/_lib/environment";
import { Box, Button } from "@material-ui/core";
import { EPOCUS_BORDER, EPOCUS_TEXT_SECONDARY } from "../_lib/epocus-palette";
import { useRoleVariant } from "../_lib/epocus-role-variant";
import { getFirstName, PerformanceHeader } from "../_lib/performance-header";
import { PerformerPerformance } from "../_lib/performer-performance";
import { PageRoot } from "../_lib/stat-primitives";
import { useEpocusSeedData } from "../_lib/use-epocus-seed-data";
import { usePerformerStats } from "../_lib/use-performer-stats";
import { useReviewerWindow } from "../_lib/use-reviewer-window";
import { useStatsFilter } from "../_lib/use-stats-filter";
import { ReviewerPerformance } from "./_lib/reviewer-performance";

export const EpocusMePage: FC = () => {
  const user = useUser();
  const variant = useRoleVariant();
  const { bulkSeed } = useEpocusSeedData();
  const [filter, setFilter] = useStatsFilter();
  const [reviewerWindow, setReviewerWindow] = useReviewerWindow();
  const stats = usePerformerStats(user.id, filter);

  return (
    <PageRoot>
      {variant === "reviewer" ? (
        <ReviewerPerformance
          reviewerId={user.id}
          name={user.firstName}
          windowKey={reviewerWindow}
          onWindowChange={setReviewerWindow}
        />
      ) : (
        <>
          <PerformanceHeader
            title="My Performance"
            subtitle={`${getFirstName(user.firstName)} · personal QA stats`}
          />
          <PerformerPerformance
            stats={stats}
            filter={filter}
            onFilterChange={setFilter}
          />
        </>
      )}

      {isDevEnvironment() && (
        <Box
          display="flex"
          justifyContent="center"
          style={{ paddingBottom: 8 }}
        >
          <Button
            variant="outlined"
            size="small"
            onClick={bulkSeed}
            style={{ color: EPOCUS_TEXT_SECONDARY, borderColor: EPOCUS_BORDER }}
          >
            Seed demo data
          </Button>
        </Box>
      )}
    </PageRoot>
  );
};
